import htmx from "htmx.org";

const initializePublications = () => {
    const publications =     document.querySelectorAll('.publications');

    publications.forEach(publication => {
        const reset = publication.querySelector('[type=reset]')
        let total = publication.querySelector('.filter-total');

        publication?.addEventListener('htmx:afterRequest', () => {
            const activeSelectors = publication.querySelectorAll('.select-box--active');
            const results = publication.querySelector('#result');
            const totalResults = results.dataset.total;

            if (activeSelectors && activeSelectors.length > 0) {
                reset.removeAttribute('disabled')
            } else {
                reset.setAttribute('disabled', '');
            }

            total.textContent = totalResults;
        });

        reset?.addEventListener('click', (e) => {
            setTimeout( () => {
                htmx.ajax('GET', '?l=1&offset=0', {
                    target: '#result',
                    swap: 'innerHTML'
                }).then(() => {
                    publication.dispatchEvent(new Event('htmx:afterRequest'));
                });
            }, 10);
        })
    })
}

window.addEventListener('DOMContentLoaded', () => {
    initializePublications();
})

